import fancyselectbox from "../../../_js/cmp/fancyselectbox";
import _forecastLegend from "./forecastlegend";

export default function (widget) {
    const m = widget.m;
    const state = widget.state;
    const t = widget.txt;

    const ns = widget.ns + '__header';

    const forecastLegend = _forecastLegend(widget);


    const trellisHeader = {
        controller: function (/*props*/) {
            const ctrl = this;

            const last = {};
            ctrl.checkChanged = function () {
                const forecastData = state.forecastData || {};
                const unchanged = {
                    forecast: state.forecast === last.forecast,
                    forecasts: state.forecasts === last.forecasts,
                    forecastType: state.forecastType === last.forecastType,
                    forecast_types: forecastData.forecast_types === last.forecast_types,
                    timepoint: (state.timepoint && state.timepoint._idObj) === last.timepoint,
                    timezones: forecastData.timezones === last.timezones,
                    tzCode: state.tzCode === last.tzCode,
                };
                last.forecast = state.forecast;
                last.forecasts = state.forecasts;
                last.forecastType = state.forecastType;
                last.forecast_types = forecastData.forecast_types;
                last.timepoint = (state.timepoint && state.timepoint._idObj);
                last.timezones = forecastData.timezones;
                last.tzCode = state.tzCode;
                return unchanged;
            };

            let flatForecasts/*: Array<Object> */;
            let _lastForecastsList;
            ctrl.flattenForecasts = function () {
                if (state.forecasts !== _lastForecastsList) {
                    _lastForecastsList = state.forecasts;
                    flatForecasts = [];
                    let indent = 0;
                    const toOption = function (item) {
                        const padding = indent ?
                                        (new Array(2 * indent + 1)).join('\u2002') :
                                        '';
                        flatForecasts[flatForecasts.length] = {
                            value: item.id || '',
                            disabled: !item.id,
                            label: padding + t(item.name),
                        };
                        if (item.forecasts) {
                            indent += 1;
                            item.forecasts.forEach(toOption);
                            indent -= 1;
                        }
                    };
                    state.forecasts.forEach(toOption);
                }
                return flatForecasts;
            };

        },


        view: function (ctrl/*, props*/) {
            // ctrl.props = props || {};

            const retain = {subtree: 'retain'};
            const unchanged = ctrl.checkChanged();

            const itemClass = ns + '__item' + ns + '__item';
            const flatForecastList = ctrl.flattenForecasts();

            const forecast = unchanged.forecast && unchanged.forecasts ? retain :
                             m('span', {className: itemClass + '--forecast'},
                                 (flatForecastList.length === 1 ?
                                  t(state.forecast.name).trim() :
                                  m(fancyselectbox, {
                                      value: state.forecastId,
                                      options: flatForecastList,
                                      onchange: function (/*e*/) {
                                          state.setForecast(this.value);
                                      },
                                  })
                                 )
                             );
            let forecastType = '';
            let currentTime = '';
            let timezone = '';

            const forecastData = state.forecastData;
            if (forecastData) {

                forecastType = unchanged.forecastType && unchanged.forecast_types ? retain :
                               m('span', {className: itemClass + '--forecasttype'},
                                   (forecastData.forecast_typesArr.length === 1 ?
                                    t(state.forecastType.name) :
                                    m(fancyselectbox, {
                                        value: state.forecastType.id,
                                        options: forecastData.forecast_typesArr.map((item) => ({
                                            value: item.id,
                                            label: t(item.name)
                                        })),
                                        onchange: function (/*e*/) {
                                            state.setPlotType(this.value);
                                        },
                                    })
                                   )
                               );


                const singleTimezone = (tzCode, tzOffset) => {
                    let tzLinkToken = tzCode.toLowerCase();
                    if (tzCode.indexOf('GMT') === 0 && tzCode.length > 3) {
                        tzLinkToken = ( tzOffset % 1 === 0 ) ?
                                      String.fromCharCode(97 + (tzOffset + 24) % 24 - 1) :
                                      '';
                    }
                    return tzLinkToken ?
                           m('a', {
                                   className: ns + '__item__timezone',
                                   href: 'https://www.timeanddate.com/time/zones/' + tzLinkToken,
                                   target: '_blank',
                               },
                               tzCode
                           ) :
                           m('span', {className: ns + '__item__timezone'},
                               tzCode
                           );
                };
                // const timezones = forecastData.timezones;
                timezone = unchanged.tzCode && unchanged.timezones ? retain :
                    // (timezones.length === 1 ?
                           singleTimezone(state.tzCode, state.tzOffset// ):
                               //   m(fancyselectbox, {
                               //     className: ns+'__item__timezone',
                               //     value: state.tzOffset,
                               //     options: forecastData.timezones.map((item)=>({ value:item.offset, label:t(item.tz) })),
                               //     onchange: function (/*e*/) {
                               //       state.setTimezone(1*this.value);
                               //     },
                               //   })
                           );

                const timepoint = state.timepoint;
                if (timepoint) {
                    currentTime = unchanged.timepoint ? retain :
                                  m('span', {className: itemClass + '--timepoint'},
                                      t('$header__timepoint', {
                                          wday: t('$wdays', timepoint.wday),
                                          wday_short: t('$wdays--short', timepoint.wday),
                                          month: t('$months', timepoint.month),
                                          month_short: t('$months--short', timepoint.month),
                                          date: timepoint.date,
                                          hours: timepoint.hours,
                                          hours12: timepoint.hours12,
                                          ampm: t('$ampm', timepoint.ampm),
                                          minutes: timepoint.minutes0
                                      }),
                                      ' ',//<-- &nbsp;
                                      timezone
                                  );
                }
            }

            return (
                m('div', {className: ns},
                    m('h1', {className: ns + '__heading'},
                        forecast,
                        ' ',
                        forecastType
                    ),
                    ' ',
                    currentTime,
                    ' ',
                    m(forecastLegend),
                    ''
                )
            );

        },

    };


    return trellisHeader;
}
